import { Center, Loader } from "@mantine/core";

/**
 * Suspense fallback for the lazily-imported route pages (`app/router.tsx`).
 *
 * Every leaf page except `LoginPage` is a `React.lazy` chunk, so navigating to
 * a route the browser hasn't fetched yet suspends. The boundaries live at each
 * layout's `<Outlet />` — NOT around each route element and NOT at the top of
 * the tree — so only the content area blanks while a chunk loads and the
 * AppShell chrome stays painted.
 *
 * It is also the pending state of every gate a hard load passes through —
 * `HydrateFallback` and `AuthedLayout` at `100dvh`, then `WorkspaceLayout`,
 * `RootRedirect`, `WorkspaceHome` and `PermissionRoute` at the default — so
 * consecutive waits are one spinner in one place. Each of those used to spell
 * its own `<Center mih>` (80vh, 80vh, 60vh…), and a reload walked the spinner
 * down the page one gate at a time.
 */
export function RouteFallback({ mih = "80vh" }: { mih?: string }) {
    return (
        <Center mih={mih}>
            <Loader />
        </Center>
    );
}
